import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const confirmAction = async ({
  title = 'Are you sure?',
  message = 'Do you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  const isDark = document.documentElement.getAttribute('data-pc-theme') === 'dark';

  return Swal.fire({
    title,
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,

    background: isDark ? '#1e293b' : '#ffffff',
    color: isDark ? '#ffffff' : '#000000'
  }).then((result) => result.isConfirmed);
};
